import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorHeader: {
		id: 'admin-hub-focused-task.error.header',
		defaultMessage: "We're not sure what went wrong",
		description: 'The header text to show on a step with an error.',
	},
	closeDrawerButton: {
		id: 'admin-hub-focused-task.close.drawer.button',
		defaultMessage: 'Close',
		description: 'The label for the close drawer button',
	},
	progressTracker: {
		id: 'admin-hub-focused-task.progress.tracker',
		defaultMessage: 'Progress tracker',
		description: 'The aria-label for the progress tracker',
	},
	defaultBackButtonText: {
		id: 'admin-hub-focused-task.default.back.button.text',
		defaultMessage: 'Back',
		description: 'The text for the back button',
	},
	defaultNextButtonText: {
		id: 'admin-hub-focused-task.default.next.button.text',
		defaultMessage: 'Next',
		description: 'The text for the next button',
	},
	closeConfirmText: {
		id: 'admin-hub-focused-task.close.confirm.text',
		defaultMessage: `When you close this window, we don't save your progress. Are you sure you want to continue?`,
		description:
			'When the user closes the focused task, show this message if they have inputed values.',
	},
});
